import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const CallToAction = () => {
  const { t } = useTranslation();

  return (
    <div className='ltn__call-to-action-area call-to-action-6 before-bg-bottom'>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-12'>
            <div className='call-to-action-inner call-to-action-inner-6 ltn__secondary-bg position-relative'>
              <div className='coll-to-info text-color-white'>
                <h1>{t('callToAction.title')}</h1>
                <p>{t('callToAction.description')}</p>
              </div>
              <div className='btn-wrapper'>
                <Link to='/contact' className='btn btn-effect-3 btn-white'>
                  {t('callToAction.exploreProperties')}{' '}
                  <i className='icon-next'></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
